// @flow
import React from 'react'
import ButtonLink from './ButtonLink'

const SignupButton = () => (
  <ButtonLink to="/signup">Start tracking goals</ButtonLink>
)

export default SignupButton


// WEBPACK FOOTER //
// ./src/components/shared/SignupButton.js